// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-text .item-title{
    width:50%
}
.image-area {
  position: relative;
  width: 50%;
 }
.image-area img {
  max-width: 100%;
  height: auto;
}

.kt-notification-v2__item .kt-notification-v2__item-icon {
  height: 40px !important;
  width: 40px !important;
  min-width: 40px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/site-themes/theme-details/theme-details.component.css"],"names":[],"mappings":"AAAA;IACI;AACJ;AACA;EACE,kBAAkB;EAClB,UAAU;CACX;AACD;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B","sourcesContent":[".item-text .item-title{\r\n    width:50%\r\n}\r\n.image-area {\r\n  position: relative;\r\n  width: 50%;\r\n }\r\n.image-area img {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.kt-notification-v2__item .kt-notification-v2__item-icon {\r\n  height: 40px !important;\r\n  width: 40px !important;\r\n  min-width: 40px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
